import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import PieGraph from "../../../general/PieGraph";
import styles from "./ObraL1.module.css";
import { ObraStore } from "./ObraStore";

function ObraL1({ distrito }) {
  const [gerenciaPropriedade, setGerenciaPropriedade] = useState(null);
  const [maoDeObra, setMaoDeObra] = useState(null);
  const [organizacao, setOrganizacao] = useState(null);

  const [gerenciaPropriedadeOldValue, setGerenciaPropriedadeOldValue] =
    useState(null);
  const [maoDeObraOldValue, setMaoDeObraOldValue] = useState(null);
  const [organizacaoOldValue, setOrganizacaoOldValue] = useState(null);

  const gerenciaPropriedadeValue = ObraStore(
    (state) => state.gerenciaPropriedadeValue
  );

  const maoDeObraValue = ObraStore((state) => state.maoDeObraValue);

  const organizacaoValue = ObraStore((state) => state.organizacaoValue);

  const setGerenciaPropriedadeValue = ObraStore(
    (state) => state.setGerenciaPropriedadeValue
  );

  const setMaoDeObraValue = ObraStore((state) => state.setMaoDeObraValue);

  const setOrganizacaoValue = ObraStore((state) => state.setOrganizacaoValue);

  const setGerenciaPropriedadeImage = ObraStore(
    (state) => state.setGerenciaPropriedadeImage
  );

  const setMaoDeObraImage = ObraStore((state) => state.setMaoDeObraImage);

  const setOrganizacaoImage = ObraStore((state) => state.setOrganizacaoImage);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [gerenciaPropriedade, maoDeObra, organizacao] = await Promise.all([
          Api.getGerenciaPropriedade(distrito, null, maoDeObraValue, organizacaoValue),
          Api.getMaoDeObra(distrito, gerenciaPropriedadeValue, null, organizacaoValue),
          Api.getOrganizacao(distrito, gerenciaPropriedadeValue, maoDeObraValue, null),
        ]);
        setGerenciaPropriedade(Functions.buildPieGraphParams2(gerenciaPropriedade));
        setMaoDeObra(Functions.buildPieGraphParams2(maoDeObra));
        setOrganizacao(Functions.buildPieGraphParams2(organizacao));
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    };
    fetchData();
  }, [distrito, gerenciaPropriedadeValue, maoDeObraValue, organizacaoValue]);

  const onGerenciaPropriedadeClick = (value) => {
    setGerenciaPropriedadeValue(value);
  };

  const onMaoDeObraClick = (value) => {
    setMaoDeObraValue(value);
  };

  const onOrganizacaoClick = (value) => {
    setOrganizacaoValue(value);
  };

  return (
    <div className={styles.obraL1}>
      <div className={styles.smallPiegraph}>
        {gerenciaPropriedade && (
          <PieGraph
            data={gerenciaPropriedade}
            text="GERÊNCIA DA PROPRIEDADE"
            onLegendClick={onGerenciaPropriedadeClick}
            currentValue={gerenciaPropriedadeValue}
            oldValue={gerenciaPropriedadeOldValue}
            onOldValue={setGerenciaPropriedadeOldValue}
            onImageReady={setGerenciaPropriedadeImage}
          />
        )}
      </div>

      <div className={styles.smallPiegraph}>
        {maoDeObra && (
          <PieGraph
            data={maoDeObra}
            text="MÃO DE OBRA"
            onLegendClick={onMaoDeObraClick}
            currentValue={maoDeObraValue}
            oldValue={maoDeObraOldValue}
            onOldValue={setMaoDeObraOldValue}
            onImageReady={setMaoDeObraImage}
          />
        )}
      </div>

      <div className={styles.smallPiegraph}>
        {organizacao && (
          <PieGraph
            data={organizacao}
            text="PARTICIPA DE ORGANIZAÇÃO"
            onLegendClick={onOrganizacaoClick}
            currentValue={organizacaoValue}
            oldValue={organizacaoOldValue}
            onOldValue={setOrganizacaoOldValue}
            onImageReady={setOrganizacaoImage}
          />
        )}
      </div>
    </div>
  );
}

export default ObraL1;
